// removed by extract-text-webpack-plugin
module.exports = {"sidebarHeader":"CentricUI__LeftSidebar__LeftSidebarHeader__sidebarHeader","libraryExtra":"CentricUI__LeftSidebar__LeftSidebarHeader__libraryExtra"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/sidebar/LeftSidebar/LeftSidebarHeader.css
// module id = 986
// module chunks = 10